<!-- Asking Alert -->
<div *ngIf="type == 'ask'" class="container row cont-element dialog">
    <div class="row container cont-element">
        <div class="col-md-2 container d-flex justify-content-center justify-content-md-start align-items-center mb-3 mb-md-0"
            *ngIf="data.matIcon != '' && data.matIcon != undefined">
            <div class="row align-items-center icon" style="height: 64px; width: 64px;">
                <mat-icon style="width: 100%;">{{data.matIcon}}</mat-icon>
                {{data.matIcon}}
            </div>
        </div>
        <div class="col-md-3 container d-flex justify-content-center justify-content-md-start align-items-center mb-md-0"
            *ngIf="data.imagePath != '' && data.imagePath != undefined">
            <div class="row align-items-center icon" style="height: 80px; width: 80px;">
                <img alt="" class="icon-image" [src]="data.imagePath">
            </div>
        </div>
        <div
            class="container d-flex row cont-element col-12 justify-content-center align-items-center d-flex flex-column">
            <div class="conatiner row align-items-center mx-0 justify-content-center"
                style="font-size: 22px;font-weight: 700;">
                {{data.heading }}
            </div>
            <div class="conatiner row align-items-center mx-0 ff-inter justify-content-center text-center">
                {{data.message }}
            </div>
        </div>
    </div>
    <div class="row container cont-element">
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center mt-3" *ngIf="cancelLabel">
            <button mat-stroked-button type="button" (click)="onCancelClick()"
                class="action-button btn-stroked">{{cancelLabel }}</button>
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center mt-3" *ngIf="submitLabel">
            <button mat-raised-button type="button" class="action-button btn-submit"
                (click)="onSubmitClick()">{{submitLabel }}</button>
        </div>
    </div>
</div>
<img *ngIf="data.cancelAble || type == 'error' || type == 'success' " src="/icons/ic_close.svg" class="cancel-icon"
    alt="" (click)="onCancelClick()" width="22px" height="22px">
<!-- Success/Error Alert -->

<div *ngIf="type == 'success' || type == 'error'">
    <div class="row cont-element flex-column justify-content-center align-items-center">
        <div class="row justify-content-center align-items-center mt-4" *ngIf="imagePath">
            <img alt="" [src]="imagePath" height="60px" width="60px">
        </div>
        <div class="col-12 row flex-column cont-element justify-content-center align-items-center mt-3 mb-4">
            <div class="row justify-content-center align-items-center mb-2 ff-inter-semibold" style="font-size: 20px; ">
                {{data.heading }}
            </div>
            <div class="d-flex text-center justify-content-center flex-column align-items-center mt-1 ff-inter"
                style="font-size: 14px; padding: 0 10px;">
                <span>{{data.message }}</span>
                <a *ngIf="data.linkText" class="mt-2"
                    style="color: blue; text-decoration: underline; cursor: pointer; font-weight: 500;"
                    (click)="onLinkClick()">{{ data.linkText }}</a>
            </div>
            <button *ngIf="data.btnSuccess" mat-raised-button type="button"
                class="ff-inter action-button btn-submit mt-4" style="width: 80%;"
                (click)="onBtnSuccess()">{{data.btnSuccess }}</button>
        </div>
    </div>
</div>